import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('workers')

export const FETCH_LIST = createType('FETCH_LIST')
export const LIST_FETCHED = createType('LIST_FETCHED')
export const SHOW_INFO_DIALOG = createType('SHOW_INFO_DIALOG')
export const HIDE_INFO_DIALOG = createType('HIDE_INFO_DIALOG')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const SET_ACTIVE_STATE = createType('SET_ACTIVE_STATE')
export const UPDATED = createType('UPDATED')
export const SHOW_WORKER_BALANCE_DIALOG = createType('SHOW_WORKER_BALANCE_DIALOG')
export const SHOW_REJECT_JOIN_REQUEST_DIALOG = createType('SHOW_REJECT_JOIN_REQUEST_DIALOG')
export const SET_IS_VETERAN = createType('SET_IS_VETERAN')
export const SHOW_DEDUCTION_DEPOSIT = createType('SHOW_DEDUCTION_DEPOSIT')

